import { render, staticRenderFns } from "./promo-resources-toolbar.vue?vue&type=template&id=cf2ce294&scoped=true"
import script from "./promo-resources-toolbar.vue?vue&type=script&lang=js"
export * from "./promo-resources-toolbar.vue?vue&type=script&lang=js"
import style0 from "./promo-resources-toolbar.vue?vue&type=style&index=0&id=cf2ce294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2ce294",
  null
  
)

export default component.exports